import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

/**
 * react-snap bakes pre-rendered HTML for every route into build/ at build
 * time (postbuild script). When a real browser lands on such a route the
 * DOM under #root is already populated — we must call `hydrateRoot()` so
 * React attaches to that markup instead of `createRoot()` (which would
 * blow it away and cause a flash). During dev (empty shell) we fall
 * back to `createRoot()`.
 *
 * Detection heuristic: an empty #root has zero children. Pre-rendered
 * output always contains the App tree, so children > 0 → hydrate.
 */
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(tree);
}
